import {
    LayoutDashboard,
    Users,
    UserCheck,
    Bell,
    Clock,
    IndianRupee,
    TrendingUp,
    UserPlus,
    BookOpen,
    FileText,
    Calendar,
    Target,
    Users2,
    BarChart3,
    Package,
    Truck,
    FileBarChart,
    Building2,
    Shield,
    MapPin,
    CreditCard,
    MessageSquare,
    Database,
    UserCog,
    FileCheck,
    GraduationCap,
    UserX,
    AlertTriangle,
    Download,
    ClipboardList,
    Activity,
    Globe,
    Lock,
    Eye,
    Upload,
    Briefcase,
    Award,
    CheckCircle,
    ArrowRight,
    Plus,
    Edit,
    RefreshCw,
    Settings,
    HelpCircle,
    Phone,
    Mail,
    MessageCircle,
    Bot,
    Headphones,
    GitBranch,
    ShoppingCart,
    ListChecks,
    Key,
    User,
    LogOut,
    Building,
    Map,
    Navigation,
    Video,
    Search
} from 'lucide-react';
import { USER_ROLES } from '../utils/constants';

export const allNavigationItems = {
    dashboard: {
        id: 'dashboard',
        label: 'Dashboard',
        icon: LayoutDashboard,
        roles: [],
        permissionKey: 'dashboard',
        path: '/dashboard'
    },

    // HRMS - Human Resource Management System
    hrms: {
        id: 'hrms',
        label: 'HRMS',
        icon: Users,
        hasSubItems: true,
        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
        checkHRMSPermission: true,
        subItems: {
            hr_backoffice: {
                id: 'hr_backoffice',
                label: 'HR Overview',
                icon: ClipboardList,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'hr_backoffice',
                path: '/hrms/back-office'
            },
            recruitment: {
                id: 'recruitment',
                label: 'Talent Acquisition',
                icon: UserPlus,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'recruitment',
                path: '/hrms/recruitment'
            },
            onboarding: {
                id: 'onboarding',
                label: 'Onboarding',
                icon: UserCheck,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'onboarding',
                path: '/hrms/onboarding'
            },
            employee_database: {
                id: 'employee_database',
                label: 'Employee Directory',
                icon: Database,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'employee_management',
                path: '/employee_list' // Canonical entry for Employee DB
            },
            organization_chart: {
                id: 'organization_chart',
                label: 'Organization Chart',
                icon: GitBranch,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'employee_management',
                path: '/organization_chart'
            },
            attendance_leave: {
                id: 'attendance_leave',
                label: 'Time & Attendance',
                icon: Clock,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE, USER_ROLES.EMPLOYEE],
                permissionKey: 'attendance',
                path: '/attendance_dashboard' // Canonical entry
            },
            payroll: {
                id: 'payroll',
                label: 'Payroll',
                icon: IndianRupee,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER],
                permissionKey: 'payroll',
                path: '/payroll_dashboard' // Canonical entry
            },
            performance: {
                id: 'performance',
                label: 'Performance',
                icon: TrendingUp,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE, USER_ROLES.EMPLOYEE],
                permissionKey: 'performance',
                path: '/performance_dashboard' // Canonical entry
            },
            training: {
                id: 'training',
                label: 'Learning & Development',
                icon: BookOpen,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE, USER_ROLES.EMPLOYEE],
                permissionKey: 'training',
                path: '/hrms/training' // Canonical entry
            },
            exit_management: {
                id: 'exit_management',
                label: 'Offboarding',
                icon: UserX,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE, USER_ROLES.EMPLOYEE],
                permissionKey: 'exit_management',
                path: '/hrms/exit' // Canonical entry
            },
            compliance_policy: {
                id: 'compliance_policy',
                label: 'Compliance & Policy',
                icon: Shield,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'compliance_policy',
                path: '/hrms/compliance-policy' // Canonical entry
            },
            analytics_reporting: {
                id: 'analytics_reporting',
                label: 'HR Analytics',
                icon: BarChart3,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.HR_MANAGER, USER_ROLES.HR_EXECUTIVE],
                permissionKey: 'reports',
                path: '/hr_analytics_dashboard' // Canonical entry
            }
        }
    },

    // CRM / Sales
    crm_sales: {
        id: 'crm_sales',
        label: 'CRM / Sales',
        icon: Target,
        hasSubItems: true,
        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER],
        checkCRMPermission: true,
        subItems: {
            global_crm_search: {
                id: 'global_crm_search',
                label: 'Lead & Customer Search',
                icon: Search,
                checkCRMPermission: true,
                path: '/crm/global-search'
            },
            lead_management: {
                id: 'lead_management',
                label: 'Lead Management',
                icon: Target,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER],
                permissionKey: 'lead_management',
                subItems: {
                    lead_dashboard: { id: 'lead_dashboard', label: 'Lead Dashboard', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/lead_dashboard' },
                    lead_sources_capture: { id: 'lead_sources_capture', label: 'Lead Sources & Capture', icon: Plus, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.EXPORT_MANAGER, USER_ROLES.DISPATCH_MANAGER], path: '/lead_sources_capture' },
                    add_lead: { id: 'add_lead', label: 'Add Lead', icon: UserPlus, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/manual_lead_entry' },
                    pending_video_verification: { id: 'pending_video_verification', label: 'Pending Video Verification', icon: Video, roles: [USER_ROLES.SUPER_ADMIN], path: '/pending_video_verification' },
                    lead_list_filters: { id: 'lead_list_filters', label: 'Lead List & Filters', icon: Users, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/lead_list_filters' },
                    lead_assignment: { id: 'lead_assignment', label: 'Lead Assignment', icon: UserCheck, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/lead_assignment' },
                    lead_activities: { id: 'lead_activities', label: 'Lead Activities', icon: Activity, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/lead_activities' },
                    lead_scoring_qualification: { id: 'lead_scoring_qualification', label: 'Lead Scoring & Qualification', icon: BarChart3, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/lead_scoring_qualification' },
                    convert_opportunity: { id: 'convert_opportunity', label: 'Convert to Opportunity', icon: ArrowRight, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/convert_opportunity' },
                    tender_lead: { id: 'tender_lead', label: 'Tender Lead', icon: FileText, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/tender_lead' }
                }
            },
            field_sales: {
                id: 'field_sales',
                label: 'Field Sales',
                icon: MapPin,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER],
                permissionKey: 'field_sales',
                subItems: {
                    field_sales_dashboard: { id: 'field_sales_dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/field_sales_dashboard' },
                    route_plans: { id: 'route_plans', label: 'Route Plans', icon: Target, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/route_plans' },
                    todays_visits: { id: 'todays_visits', label: "Today's Visits", icon: Calendar, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/todays_visits' }
                }
            },
            opportunity_pipeline: {
                id: 'opportunity_pipeline',
                label: 'Opportunity Management',
                icon: Target,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER],
                permissionKey: 'opportunity_management',
                subItems: {
                    'Opportunity-dashboard': { id: 'Opportunity-dashboard', label: 'Opportunities', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/opportunity_pipeline' },
                    tasks_followups: { id: 'tasks_followups', label: 'Tasks & Follow-ups', icon: Calendar, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/tasks_followups' },
                    close_won_lost: { id: 'close_won_lost', label: 'Close Won/Lost', icon: CheckCircle, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/close_won_lost' }
                }
            },
            quotation_proposal: {
                id: 'quotation_proposal',
                label: 'Quotation & Proposal',
                icon: FileText,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER],
                permissionKey: 'quotation_management',
                subItems: {
                    quotation_dashboard: { id: 'quotation_dashboard', label: 'Quotation Dashboard', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/crm/quotation-proposal/dashboard' },
                    create_quotes: { id: 'create_quotes', label: 'Quotations Management', icon: FileText, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/crm/quotation-proposal/create-quotes' },
                    convert_order: { id: 'convert_order', label: 'Convert to Order', icon: ShoppingCart, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/crm/quotation-proposal/convert-order' }
                }
            },
            orders_logistics: {
                id: 'orders_logistics',
                label: 'Orders & Logistics',
                icon: Package,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER],
                permissionKey: 'order_management',
                subItems: {
                    order_dashboard: { id: 'order_dashboard', label: 'Order Dashboard', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/order_dashboard' },
                    order_management: { id: 'order_management', label: 'Order Management', icon: Package, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/order_management' },
                    inventory_sync: { id: 'inventory_sync', label: 'Inventory Sync', icon: RefreshCw, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/inventory_sync' },
                    batch_expiry: { id: 'batch_expiry', label: 'Batch & Expiry Management', icon: AlertTriangle, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/batch_expiry' }
                }
            },
            customer_relationship: {
                id: 'customer_relationship',
                label: 'Customer Relationship',
                icon: Users2,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER],
                permissionKey: 'customer_management',
                subItems: {
                    customer_360: { id: 'customer_360', label: 'Customer 360°', icon: User, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/customer_360' },
                    customer_activities: { id: 'customer_activities', label: 'Customer Activities', icon: Activity, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/customer_activities' },
                    tickets_feedback: { id: 'tickets_feedback', label: 'Tickets Management', icon: HelpCircle, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/tickets_feedback' },
                    // product_analytics: { id: 'product_analytics_crm', label: 'Product Analytics', icon: BarChart3, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/customer-relationship/product-analytics' },
                    caller_popups: { id: 'caller_popups', label: 'Caller Pop-ups', icon: Phone, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/caller_popups' }
                }
            },
            customer_payment: {
                id: 'customer_payment',
                label: 'Customer Payment',
                icon: CreditCard,
                hasSubItems: false,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER, USER_ROLES.HR_MANAGER],
                permissionKey: 'customer_payment',
                path: '/crm/customer-payments'
            },
            crm_analytics_reporting: {
                id: 'crm_analytics_reporting',
                label: 'Analytics & Reporting',
                icon: BarChart3,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER],
                permissionKey: 'analytics',
                subItems: {
                    sales_crm_dashboards: { id: 'sales_crm_dashboards', label: 'Sales/CRM Dashboards', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/sales_dashboard' },
                    quote_order_tracking: { id: 'quote_order_tracking', label: 'Quote → Accepted', icon: TrendingUp, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/quote_order_dashboard' },
                    product_analytics: { id: 'product_analytics', label: 'Product Analytics', icon: BarChart3, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/product_analytics' },
                    financial_analytics: { id: 'financial_analytics', label: 'Financial Analytics', icon: IndianRupee, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/financial_analytics' },
                    logistics_ops_boards: { id: 'logistics_ops_boards', label: 'Courier Analytics', icon: Truck, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/crm/logistics/shipments' },
                    google_analytics: {
                        id: 'google_analytics',
                        label: 'Website Traffic (GA4)',
                        icon: Globe,
                        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER],
                        permissionKey: 'analytics',
                        path: '/google-analytics'
                    },
                    // party_financials: { id: 'party_financials', label: 'Party Financials (Marg ERP)', icon: IndianRupee, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER, USER_ROLES.SUPPORT_MANAGER], path: '/party_financials' }
                }
            },
            target_achievement: {
                id: 'target_achievement',
                label: 'Target vs Achievement',
                icon: Target,
                hasSubItems: true,
                roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER],
                permissionKey: 'target_achievement',
                subItems: {
                    targets_dashboard: { id: 'targets_dashboard', label: 'Targets Dashboard', icon: LayoutDashboard, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/targets_dashboard' },
                    created_targets: { id: 'created_targets', label: 'Target Management', icon: ClipboardList, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/created_targets' },
                    schedules: { id: 'schedules', label: 'Schedules', icon: Calendar, roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_EXECUTIVE, USER_ROLES.BUSINESS_RELATIONSHIP_MANAGER, USER_ROLES.BUSINESS_DEVELOPMENT_EXECUTIVE, USER_ROLES.EXPORT_MANAGER, USER_ROLES.EXPORT_EXECUTIVE, USER_ROLES.DISPATCH_MANAGER], path: '/schedules' }
                }
            }
        }
    },

    system_management: {
        id: 'system_management',
        label: 'System Management',
        icon: Settings,
        hasSubItems: true,
        // Visible to any user who has HRMS OR CRM permissions
        // (handled by checkSystemPermission in DynamicSidebar)
        roles: [
            USER_ROLES.SUPER_ADMIN,
            USER_ROLES.HR_MANAGER,
            USER_ROLES.SALES_MANAGER,
            USER_ROLES.EXPORT_MANAGER
        ],
        checkSystemPermission: true,
        subItems: {
            // HRMS sub-group — visible only to HRMS roles + Super Admin
            system_hrms: {
                id: 'system_hrms',
                label: 'HRMS',
                icon: Users,
                hasSubItems: true,
                roles: [
                    USER_ROLES.SUPER_ADMIN,
                    USER_ROLES.HR_MANAGER
                ],
                permissionKey: 'system_hrms',
                subItems: {
                    location_management: {
                        id: 'location_management',
                        label: 'Location',
                        icon: MapPin,
                        roles: [],
                        permissionKey: 'system_hrms',
                        path: '/location_management',
                        hasSubItems: false
                    },
                    department_management: {
                        id: 'department_management',
                        label: 'Department',
                        icon: Building,
                        roles: [],
                        permissionKey: 'system_hrms',
                        path: '/department_role_mapping',
                        hasSubItems: false
                    },
                    hrms_configuration: {
                        id: 'hrms_configuration',
                        label: 'Masters',
                        icon: Database,
                        roles: [],
                        permissionKey: 'system_hrms',
                        path: '/hrms_configuration',
                        hasSubItems: false
                    },
                    global_leave_configuration: {
                        id: 'global_leave_configuration',
                        label: 'Global Leave Config',
                        icon: Globe,
                        roles: [],
                        permissionKey: 'attendance',
                        path: '/global_leave_configuration',
                        hasSubItems: false
                    }
                }
            },
            // CRM sub-group — visible only to CRM/Sales roles + Super Admin
            system_crm: {
                id: 'system_crm',
                label: 'CRM',
                icon: Target,
                hasSubItems: true,
                roles: [
                    USER_ROLES.SUPER_ADMIN,
                    USER_ROLES.SALES_MANAGER,
                    USER_ROLES.EXPORT_MANAGER
                ],
                permissionKey: 'system_crm',
                subItems: {
                    crm_configuration: {
                        id: 'crm_configuration',
                        label: 'Masters',
                        icon: Database,
                        roles: [],
                        permissionKey: 'system_crm',
                        path: '/crm_configuration',
                        hasSubItems: false
                    }
                }
            }
        }
    },

    employee_self_service: {
        id: 'employee_self_service',
        label: 'My Services',
        icon: User,
        hasSubItems: true,
        permissionKey: 'self_service',
        subItems: {
            employee_dashboard: { id: 'employee_dashboard', label: 'Dashboard', icon: LayoutDashboard, permissionKey: 'self_service', path: '/employee_self_service' },
            my_profile: { id: 'my_profile', label: 'My Profile', icon: User, permissionKey: 'self_service', path: '/my_profile' },
            my_attendance: { id: 'my_attendance', label: 'My Attendance', icon: Clock, permissionKey: 'my_attendance', path: '/my_attendance' },
            my_interviews: { id: 'my_interviews', label: 'My Interviews', icon: Video, permissionKey: 'my_interviews', path: '/my_interviews' },
            background_verification: { id: 'background_verification', label: 'Background Verification', icon: Shield, permissionKey: 'background_verification', path: '/hrms/onboarding?tab=backgroundVerification' },
            my_payslips: { id: 'my_payslips', label: 'My Payslips', icon: CreditCard, permissionKey: 'my_payslip', path: '/my_payslips' },
            my_training: { id: 'my_training', label: 'My Training', icon: BookOpen, permissionKey: 'my_training', path: '/my_training' },
            my_performance: { id: 'my_performance', label: 'My Performance', icon: TrendingUp, permissionKey: 'my_performance', path: '/my_performance' },
            apply_leave: { id: 'apply_leave', label: 'Apply Leave', icon: Calendar, permissionKey: 'leave_request', path: '/apply_leave' },
            policies: { id: 'policies', label: 'Policies', icon: FileText, permissionKey: 'policies', path: '/policies' },
            submit_resignation: { id: 'submit_resignation', label: 'Submit Resignation', icon: UserX, permissionKey: 'submit_resignation', path: '/submit_resignation' },
            internal_tickets: { id: 'internal_tickets', label: 'Internal Tickets', icon: HelpCircle, permissionKey: 'self_service', path: '/my_tickets' },
            internal_approvals: { id: 'internal_approvals', label: 'Internal Approvals', icon: FileCheck, permissionKey: 'self_service', path: '/my_approvals' }
        }
    },
    notifications: {
        id: 'notifications',
        label: 'Notifications',
        icon: Bell,
        roles: [],
        path: '/notifications'
    },
};
